import logger from '../logger';

let defaults: any = {
    Locale: 'en-US',
    Currency: 'USD'
};

const locale: string = navigator.languages && navigator.languages.length
    ? navigator.languages[0]
    : navigator.language;

const longDateOptions: Intl.DateTimeFormatOptions = { year: "numeric", month: "2-digit", day: "2-digit",hourCycle: "h23",hour:"2-digit",minute:"2-digit",second:"2-digit" };

const FormatFullDate = function (params: any) {
    try {
        return Intl.DateTimeFormat([locale,defaults.Locale], longDateOptions).format((params.value === undefined ? params : params.value) as Date);
    } catch (err) {
        try {
            return Intl.DateTimeFormat([locale, defaults.Locale], longDateOptions).format(new Date((params.value === undefined ? params : params.value)));
        } catch (err) {
            logger.error(err);
        }
    }
    return null;
}

const FormatCurrency = function (params: any, currency?: string|null) {
    if (isNaN((params.value === undefined ? params : params.value)))
        return '';
    try {        
        const formatted = Intl.NumberFormat([locale, defaults.Locale], { style: 'currency', currencySign: 'accounting', currencyDisplay:'symbol', currency: (currency === undefined || currency===null ? defaults.Currency : currency) }).format((params.value === undefined ? params : params.value) as number);
        return formatted.includes("US$") ? formatted.replace("US$", "$") : formatted;
    } catch (err) {
        logger.error(err);
        return null;
    }
};

export { FormatCurrency, FormatFullDate }